/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Misc_Posts_Expectlist_Planetsstrong2Inputs */

const id_misc_posts_expectlist_planetsstrong2 = /** @type {(inputs: Misc_Posts_Expectlist_Planetsstrong2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`23 Planet untuk Dijelajahi`)
};

const ms_misc_posts_expectlist_planetsstrong2 = /** @type {(inputs: Misc_Posts_Expectlist_Planetsstrong2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`23 Planet untuk Diterokai`)
};

const da_misc_posts_expectlist_planetsstrong2 = /** @type {(inputs: Misc_Posts_Expectlist_Planetsstrong2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`23 Planeter at Udforske`)
};

const de_misc_posts_expectlist_planetsstrong2 = /** @type {(inputs: Misc_Posts_Expectlist_Planetsstrong2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`23 Planeten zum Erkunden`)
};

const en_us2_misc_posts_expectlist_planetsstrong2 = /** @type {(inputs: Misc_Posts_Expectlist_Planetsstrong2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`23 Planets to Explore`)
};

const es_es2_misc_posts_expectlist_planetsstrong2 = /** @type {(inputs: Misc_Posts_Expectlist_Planetsstrong2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`23 planetas para explorar`)
};

const es_mx2_misc_posts_expectlist_planetsstrong2 = /** @type {(inputs: Misc_Posts_Expectlist_Planetsstrong2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`23 planetas para explorar`)
};

const fil_misc_posts_expectlist_planetsstrong2 = /** @type {(inputs: Misc_Posts_Expectlist_Planetsstrong2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`23 Planeta na Tuklasin`)
};

const fr_misc_posts_expectlist_planetsstrong2 = /** @type {(inputs: Misc_Posts_Expectlist_Planetsstrong2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`23 planètes à explorer`)
};

const it_misc_posts_expectlist_planetsstrong2 = /** @type {(inputs: Misc_Posts_Expectlist_Planetsstrong2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`23 pianeti da esplorare`)
};

const hu_misc_posts_expectlist_planetsstrong2 = /** @type {(inputs: Misc_Posts_Expectlist_Planetsstrong2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`23 felfedezhető bolygó`)
};

const nl_misc_posts_expectlist_planetsstrong2 = /** @type {(inputs: Misc_Posts_Expectlist_Planetsstrong2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`23 planeten om te verkennen`)
};

const no_misc_posts_expectlist_planetsstrong2 = /** @type {(inputs: Misc_Posts_Expectlist_Planetsstrong2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`23 planeter å utforske`)
};

const pl_misc_posts_expectlist_planetsstrong2 = /** @type {(inputs: Misc_Posts_Expectlist_Planetsstrong2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`23 planety do odkrycia`)
};

const pt_br2_misc_posts_expectlist_planetsstrong2 = /** @type {(inputs: Misc_Posts_Expectlist_Planetsstrong2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`23 planetas para explorar`)
};

const pt_misc_posts_expectlist_planetsstrong2 = /** @type {(inputs: Misc_Posts_Expectlist_Planetsstrong2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`23 planetas para explorar`)
};

const ro_misc_posts_expectlist_planetsstrong2 = /** @type {(inputs: Misc_Posts_Expectlist_Planetsstrong2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`23 de planete de explorat`)
};

const fi_misc_posts_expectlist_planetsstrong2 = /** @type {(inputs: Misc_Posts_Expectlist_Planetsstrong2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`23 planeettaa tutkittavana`)
};

const sv_misc_posts_expectlist_planetsstrong2 = /** @type {(inputs: Misc_Posts_Expectlist_Planetsstrong2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`23 planeter att utforska`)
};

const vi_misc_posts_expectlist_planetsstrong2 = /** @type {(inputs: Misc_Posts_Expectlist_Planetsstrong2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`23 hành tinh để khám phá`)
};

const tr_misc_posts_expectlist_planetsstrong2 = /** @type {(inputs: Misc_Posts_Expectlist_Planetsstrong2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Keşfedilecek 23 Gezegen`)
};

const cs_misc_posts_expectlist_planetsstrong2 = /** @type {(inputs: Misc_Posts_Expectlist_Planetsstrong2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`23 planet k prozkoumání`)
};

const bg_misc_posts_expectlist_planetsstrong2 = /** @type {(inputs: Misc_Posts_Expectlist_Planetsstrong2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`23 планети за изследване`)
};

const ru_misc_posts_expectlist_planetsstrong2 = /** @type {(inputs: Misc_Posts_Expectlist_Planetsstrong2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`23 планеты для исследования`)
};

const uk_misc_posts_expectlist_planetsstrong2 = /** @type {(inputs: Misc_Posts_Expectlist_Planetsstrong2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`23 планети для дослідження`)
};

const ar_misc_posts_expectlist_planetsstrong2 = /** @type {(inputs: Misc_Posts_Expectlist_Planetsstrong2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`23 كوكبًا لاستكشافها`)
};

const hi_misc_posts_expectlist_planetsstrong2 = /** @type {(inputs: Misc_Posts_Expectlist_Planetsstrong2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`23 ग्रह`)
};

const th_misc_posts_expectlist_planetsstrong2 = /** @type {(inputs: Misc_Posts_Expectlist_Planetsstrong2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`23 ดาวเคราะห์ให้สำรวจ`)
};

const ja_misc_posts_expectlist_planetsstrong2 = /** @type {(inputs: Misc_Posts_Expectlist_Planetsstrong2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`探索可能な23の惑星`)
};

const zh_cn2_misc_posts_expectlist_planetsstrong2 = /** @type {(inputs: Misc_Posts_Expectlist_Planetsstrong2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`23颗星球待探索`)
};

const zh_hant1_misc_posts_expectlist_planetsstrong2 = /** @type {(inputs: Misc_Posts_Expectlist_Planetsstrong2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`23顆星球待探索`)
};

const ko_misc_posts_expectlist_planetsstrong2 = /** @type {(inputs: Misc_Posts_Expectlist_Planetsstrong2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`탐험 가능한 23개의 행성`)
};

/**
* | output |
* | --- |
* | "23 Planets to Explore" |
*
* @param {Misc_Posts_Expectlist_Planetsstrong2Inputs} inputs
* @param {{ locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }} options
* @returns {LocalizedString}
*/
const misc_posts_expectlist_planetsstrong2 = /** @type {((inputs?: Misc_Posts_Expectlist_Planetsstrong2Inputs, options?: { locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Misc_Posts_Expectlist_Planetsstrong2Inputs, { locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_misc_posts_expectlist_planetsstrong2(inputs)
	if (locale === "ms") return ms_misc_posts_expectlist_planetsstrong2(inputs)
	if (locale === "da") return da_misc_posts_expectlist_planetsstrong2(inputs)
	if (locale === "de") return de_misc_posts_expectlist_planetsstrong2(inputs)
	if (locale === "en-US") return en_us2_misc_posts_expectlist_planetsstrong2(inputs)
	if (locale === "es-ES") return es_es2_misc_posts_expectlist_planetsstrong2(inputs)
	if (locale === "es-MX") return es_mx2_misc_posts_expectlist_planetsstrong2(inputs)
	if (locale === "fil") return fil_misc_posts_expectlist_planetsstrong2(inputs)
	if (locale === "fr") return fr_misc_posts_expectlist_planetsstrong2(inputs)
	if (locale === "it") return it_misc_posts_expectlist_planetsstrong2(inputs)
	if (locale === "hu") return hu_misc_posts_expectlist_planetsstrong2(inputs)
	if (locale === "nl") return nl_misc_posts_expectlist_planetsstrong2(inputs)
	if (locale === "no") return no_misc_posts_expectlist_planetsstrong2(inputs)
	if (locale === "pl") return pl_misc_posts_expectlist_planetsstrong2(inputs)
	if (locale === "pt-BR") return pt_br2_misc_posts_expectlist_planetsstrong2(inputs)
	if (locale === "pt") return pt_misc_posts_expectlist_planetsstrong2(inputs)
	if (locale === "ro") return ro_misc_posts_expectlist_planetsstrong2(inputs)
	if (locale === "fi") return fi_misc_posts_expectlist_planetsstrong2(inputs)
	if (locale === "sv") return sv_misc_posts_expectlist_planetsstrong2(inputs)
	if (locale === "vi") return vi_misc_posts_expectlist_planetsstrong2(inputs)
	if (locale === "tr") return tr_misc_posts_expectlist_planetsstrong2(inputs)
	if (locale === "cs") return cs_misc_posts_expectlist_planetsstrong2(inputs)
	if (locale === "bg") return bg_misc_posts_expectlist_planetsstrong2(inputs)
	if (locale === "ru") return ru_misc_posts_expectlist_planetsstrong2(inputs)
	if (locale === "uk") return uk_misc_posts_expectlist_planetsstrong2(inputs)
	if (locale === "ar") return ar_misc_posts_expectlist_planetsstrong2(inputs)
	if (locale === "hi") return hi_misc_posts_expectlist_planetsstrong2(inputs)
	if (locale === "th") return th_misc_posts_expectlist_planetsstrong2(inputs)
	if (locale === "ja") return ja_misc_posts_expectlist_planetsstrong2(inputs)
	if (locale === "zh-CN") return zh_cn2_misc_posts_expectlist_planetsstrong2(inputs)
	if (locale === "zh-Hant") return zh_hant1_misc_posts_expectlist_planetsstrong2(inputs)
	return ko_misc_posts_expectlist_planetsstrong2(inputs)
});
export { misc_posts_expectlist_planetsstrong2 as "misc.posts.expectList.planetsStrong" }